module.exports = __webpack_public_path__ + "media/images/emblems/Horgen-blazon-6a2f5a2c395579a4c1aa5454fa66d225.svg";